import React from 'react';
import styled from 'styled-components';

import UnitCard from '../../../containers/dashboards/cards/UnitCard';

const StyledContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const UnitsList = ({ selectedDashboard, dashboardsObj }) => {
  const units = selectedDashboard && dashboardsObj[selectedDashboard].units;

  return (
    <StyledContainer>
      {units && units.map((unit) => <UnitCard key={unit.id} unit={unit} />)}
    </StyledContainer>
  );
};

export default UnitsList;
